const invoicesColumns = {
  invoiceNumber: {
    key: 'invoiceNumber',
    label: 'invoiceNumber',
    type: 'text',
    sortable: false,
  },
  invoiceDate: {
    key: 'invoiceDate',
    label: 'createdAt',
    type: 'date',
    sortable: 'custom',
  },
  orderIds: {
    key: 'invoiceOrders',
    label: 'orderNumber',
    type: 'function',
    sortable: false,
    get: (invoiceOrders) => {
      if (!invoiceOrders || !invoiceOrders.length) return '-';
      return invoiceOrders.map(io => io.orderId).join(', ');
    },
  },
  actions: {
    label: 'actions',
    type: 'actions',
    sortable: false,
    minWidth: 100,
    buttons: [
      {
        name: 'showInvoice',
        icon: 'fas fa-file-pdf',
        color: 'blue-light',
        showCondition: row => row.invoicePdfId,
      },
      {
        name: 'showAttachmentPdf',
        icon: 'fas fa-file-pdf',
        color: 'red-light',
        showCondition: row => row.attachmentPdfId,
      },
      {
        name: 'showAttachmentXls',
        icon: 'fas fa-file-excel',
        color: 'green',
        showCondition: row => row.attachmentXlsId,
      },
    ],
  },
};

export default invoicesColumns;
